import { render, staticRenderFns } from "./sort-link.vue?vue&type=template&id=6ac2ea11&scoped=true&"
import script from "./sort-link.vue?vue&type=script&lang=js&"
export * from "./sort-link.vue?vue&type=script&lang=js&"
import style0 from "./sort-link.vue?vue&type=style&index=0&id=6ac2ea11&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac2ea11",
  null
  
)

export default component.exports